import { Divider, Flex } from '@chakra-ui/react';
import { LegalMenu } from './LegalMenu';

export const MainFooter: React.FC = (): JSX.Element => {
  return (
    <Flex
      alignItems={{ sm: 'center' }}
      direction={{ base: 'column', md: 'row' }}
      flexWrap="wrap"
      gap={8}
      justifyContent="space-between"
    >
      <Divider borderColor="brand.gray" />
      <LegalMenu />
    </Flex>
  );
};
